import { defineStore, } from 'pinia'

import { useUserStore } from '@/store/User';
const store = useUserStore();
import ShopsApi from '@/api/PcModule/shop';
import { getSearchProduce, getRecommend } from '@/api/PcModule/home';
export const useShopStore = defineStore({
  id: 'shop',
  state: () => ({
    haveGoods: 0,
    shopData: [],
    searchplaceholder: '',
    keywordNow: '',
    hotData: [],
    stopRight: 0,
    haveCanSampleApply: 0,
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        storage: localStorage,//localStorage存储多个key
        paths: ['haveGoods', 'shopData', 'searchplaceholder', 'keywordNow','stopRight','haveCanSampleApply'],
      },
    ],
  },
  getters: {
  },
  actions: {
    // 获取购物车数量
    async getShopAction() {
      if (store.userInfo) {
        let data = await ShopsApi.getCartTotal({
          userId: store.userInfo.id,
        });
        if (data.code == 200) {
          this.haveGoods = data.data
        }
      } else {
        this.haveGoods = 0
        this.shopData = []
      }
    },
    // 获取商品清单数量
    async getCanSampleApplyAction() {
      if (store.userInfo) {
        let data = await ShopsApi.getCanSampleApplyTotal({
          userId: store.userInfo.id,
        });
        if (data.code == 200) {
          this.haveCanSampleApply = data.data
        }
      } else {
        this.haveCanSampleApply = 0
      }
    },
    // 获取购物车列表
    async getShopListAction() {
      let data = await ShopsApi.getCartList({
        userId: store.userInfo.id,
        username: store.userInfo.username,
      });
      if (data.code == 200) {
        this.shopData = data.data.cartItemVolist || []
      }
    },
    // 获取搜索提示
    async getSearchProduceAction() {
      let data = await getSearchProduce();
      this.searchplaceholder = data?.dictDataList[0].dictValue || '';
    },
    // 获取hot推荐
    async getRecommendAction() {
      let data = await getRecommend({})
      if (data?.code == 200) {
        this.hotData = data.data || [];
      }
    }
  }
})

